export const getNonce = () => {
    return window?.blink?.nonce || '';
};
//# sourceMappingURL=nonce-utils.js.map